import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/AdminLayout';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Save } from 'lucide-react';

const AddEditMember = () => {
  const { memberId } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(memberId);

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    card_number: '',
    expiration: '',
    level: 'Business',
    status: 'Actif',
    recommended_by: '',
    country: 'France'
  });
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(isEdit);

  useEffect(() => {
    if (isEdit) {
      fetchMember();
    }
  }, [memberId]);

  const fetchMember = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/members`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const members = await response.json();
        const member = members.find(m => m.id === memberId);
        if (member) {
          setFormData({
            first_name: member.first_name || '',
            last_name: member.last_name || '',
            email: member.email,
            phone: member.phone,
            card_number: member.card_number,
            expiration: member.expiration,
            level: member.level,
            status: member.status,
            recommended_by: member.recommended_by || '',
            country: member.country || 'France'
          });
        }
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setFetchLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('adminToken');
      const url = isEdit
        ? `${process.env.REACT_APP_BACKEND_URL}/api/admin/members/${memberId}`
        : `${process.env.REACT_APP_BACKEND_URL}/api/admin/members`;
      
      const method = isEdit ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        alert(isEdit ? 'Membre mis à jour avec succès' : 'Membre créé avec succès');
        navigate('/admin/members');
      } else {
        const error = await response.json();
        alert('Erreur: ' + (error.detail || 'Erreur inconnue'));
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setLoading(false);
    }
  };

  if (fetchLoading) {
    return (
      <AdminLayout>
        <div style={{ padding: '32px' }}>
          <p>Chargement...</p>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div style={{ padding: '32px' }}>
        <button
          onClick={() => navigate('/admin/members')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '24px',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--text-secondary)'
          }}
        >
          <ArrowLeft size={20} />
          <span className="body-regular">Retour</span>
        </button>

        <h1 className="hero-medium" style={{ marginBottom: '32px' }}>
          {isEdit ? 'Modifier le membre' : 'Ajouter un membre'}
        </h1>

        <form onSubmit={handleSubmit} style={{
          maxWidth: '800px',
          background: 'var(--bg-primary)',
          border: '1px solid var(--border-light)',
          padding: '32px'
        }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
            <div>
              <label className="body-regular" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 600
              }}>
                Prénom *
              </label>
              <input
                type="text"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid var(--border-light)',
                  fontSize: '14px',
                  fontFamily: 'inherit'
                }}
              />
            </div>

            <div>
              <label className="body-regular" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 600
              }}>
                Nom *
              </label>
              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid var(--border-light)',
                  fontSize: '14px',
                  fontFamily: 'inherit'
                }}
              />
            </div>

            <div>
              <label className="body-regular" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 600
              }}>
                Email *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid var(--border-light)',
                  fontSize: '14px',
                  fontFamily: 'inherit'
                }}
              />
            </div>

            <div>
              <label className="body-regular" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 600
              }}>
                Téléphone *
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid var(--border-light)',
                  fontSize: '14px',
                  fontFamily: 'inherit'
                }}
              />
            </div>

            <div>
              <label className="body-regular" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 600
              }}>
                Pays *
              </label>
              <select
                name="country"
                value={formData.country}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid var(--border-light)',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                  background: 'var(--bg-primary)'
                }}
              >
                <option value="France">France</option>
                <option value="Belgique">Belgique</option>
                <option value="Suisse">Suisse</option>
                <option value="Luxembourg">Luxembourg</option>
                <option value="Monaco">Monaco</option>
                <option value="Canada">Canada</option>
                <option value="Royaume-Uni">Royaume-Uni</option>
                <option value="États-Unis">États-Unis</option>
                <option value="Allemagne">Allemagne</option>
                <option value="Italie">Italie</option>
                <option value="Espagne">Espagne</option>
                <option value="Autre">Autre</option>
              </select>
            </div>

            <div>
              <label className="body-regular" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 600
              }}>
                Recommandé par
              </label>
              <input
                type="text"
                name="recommended_by"
                value={formData.recommended_by}
                onChange={handleChange}
                placeholder="Nom du parrain (optionnel)"
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid var(--border-light)',
                  fontSize: '14px',
                  fontFamily: 'inherit'
                }}
              />
            </div>

            <div>
              <label className="body-regular" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 600
              }}>
                Numéro de carte (16 chiffres) *
              </label>
              <input
                type="text"
                name="card_number"
                value={formData.card_number}
                onChange={handleChange}
                required
                maxLength="16"
                pattern="[0-9]{16}"
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid var(--border-light)',
                  fontSize: '14px',
                  fontFamily: 'monospace'
                }}
              />
            </div>

            <div>
              <label className="body-regular" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 600
              }}>
                Date d'expiration *
              </label>
              <input
                type="date"
                name="expiration"
                value={formData.expiration}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid var(--border-light)',
                  fontSize: '14px',
                  fontFamily: 'inherit'
                }}
              />
            </div>

            <div>
              <label className="body-regular" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 600
              }}>
                Niveau *
              </label>
              <select
                name="level"
                value={formData.level}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid var(--border-light)',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                  background: 'var(--bg-primary)'
                }}
              >
                <option value="Business">Business</option>
                <option value="Magellan">Magellan</option>
                <option value="Orlamonde">Orlamonde</option>
                <option value="Forfait">Forfait</option>
              </select>
            </div>

            <div>
              <label className="body-regular" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 600
              }}>
                Statut *
              </label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid var(--border-light)',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                  background: 'var(--bg-primary)'
                }}
              >
                <option value="Actif">Actif</option>
                <option value="Inactif">Inactif</option>
                <option value="Suspendu">Suspendu</option>
              </select>
            </div>
          </div>

          <div style={{
            marginTop: '32px',
            display: 'flex',
            gap: '12px',
            justifyContent: 'flex-end'
          }}>
            <button
              type="button"
              onClick={() => navigate('/admin/members')}
              style={{
                padding: '12px 24px',
                background: 'transparent',
                border: '1px solid var(--border-light)',
                cursor: 'pointer',
                color: 'var(--text-secondary)'
              }}
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                opacity: loading ? 0.6 : 1
              }}
            >
              <Save size={20} />
              {loading ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </AdminLayout>
  );
};

export default AddEditMember;